import { Component } from '@angular/core';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { Observable } from 'rxjs';
import { ProductByCategoriesResult } from 'src/app/Models/Product/productsCategories_model';
import Rutas from 'src/app/Models/Base/rutas';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatIconModule } from '@angular/material/icon';
import { LayoutProductsComponent } from '../layout-products/layout-products.component';

@Component({
  selector: 'app-all-products',
  templateUrl: './all-products.component.html',
  styleUrls: ['./all-products.component.scss'],
  standalone: true,
  imports: [
    CommonModule
    , RouterModule
    , NgxSkeletonLoaderModule
    , MatIconModule
    , LayoutProductsComponent
  ]
})
export class AllProductsComponent {
  dashboard = Rutas.DASHBOARD;
  isLoading$: Observable<ProductByCategoriesResult>

  constructor(
    public appStateService: AppStateService
  ) { 
    this.isLoading$ = this.appStateService.ProductService.GetProductsByCategories();
  }

  onSelect({code, isPublic, name}: any){
    this.appStateService.onSelectProduct(code, isPublic, name);
  }

  get calc(): string{
    return this.appStateService.isMobile ? '100%' : '400px'
  }

  validateCategories(producto: any){
    return !!producto.length
  }
}
